// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Analytics, getScreenFromUrl } from '@trello/atlassian-analytics';
import { PlanSelectionOverlay } from 'app/src/components/FreeTrial';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import React from 'react';
import ReactDOM from '@trello/react-dom-wrapper';
import { renderComponent } from 'app/src/components/ComponentWrapper';
const t = require('app/scripts/views/internal/teacupWithHelpers').teacupWithHelpers(
  'business_class_upsell',
);
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { View } from 'app/scripts/views/internal/view';
import { UpgradeSmartComponentConnected } from 'app/src/components/UpgradePrompts';

class BusinessClassUpsellView extends View {
  static initClass() {
    this.prototype.events = {
      'click .js-business-class-upsell-upgrade': 'upgradePrompt',
      'click .js-business-class-upsell-close': 'onClose',
    };
  }

  // Previous BC upgrade prompt is in the commit before this one
  upgradePrompt(e) {
    stopPropagationAndPreventDefault(e);
    const tempNode = document.createElement('span');
    const org = this.model.getOrganization();
    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'prompt',
      actionSubjectId: 'bcUpgradePrompt',
      source: 'pupLimitBCUpsellInlineDialog',
      containers: {
        organization: {
          id: org.id,
        },
      },
    });
    return renderComponent(
      <PlanSelectionOverlay
        orgId={org.id}
        // eslint-disable-next-line react/jsx-no-bind
        onContinue={() => window.location.assign('/business-class')}
        // eslint-disable-next-line react/jsx-no-bind
        onClose={() => {
          ReactDOM.unmountComponentAtNode(tempNode);
          return tempNode.remove();
        }}
      />,
      tempNode,
    );
  }

  onClose(e) {
    stopPropagationAndPreventDefault(e);
    return PopOver.hide();
  }

  render() {
    this.$el.html(
      t.render(() => {
        return t.div('.js-content');
      }),
    );

    const tempNode = this.$('.js-content')[0];

    renderComponent(
      <UpgradeSmartComponentConnected
        orgId={this.model.getOrganization().id}
        promptId="pupLimitPopUpPromptFull"
        additionalProps={{
          onClose: (e) => {
            stopPropagationAndPreventDefault(e);
            ReactDOM.unmountComponentAtNode(tempNode);
            PopOver.hide();
            return tempNode.remove();
          },
        }}
      />,
      tempNode,
    );

    Analytics.sendScreenEvent({
      name: 'pupLimitBCUpsellInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.get('idOrganization'),
        },
      },
      attributes: {
        location: getScreenFromUrl(),
      },
    });

    return this;
  }
}

BusinessClassUpsellView.initClass();
export { BusinessClassUpsellView };
